<div class="widget-group p-8" fxLayout="column wrap" fxFlex="100" *fuseIfOnDom >

  <table mat-table [dataSource]="sentencia.valores" #mytable class="my-table mat-elevation-z8"
  *ngIf="esMultiple">

    <ng-container matColumnDef="nombre">
      <th mat-header-cell *matHeaderCellDef> Nombre. </th>
      <td mat-cell *matCellDef="let element"> {{element.opcion.nombre}} </td>
    </ng-container>
<!--     
    <ng-container matColumnDef="descripcion">
      <th mat-header-cell *matHeaderCellDef> Descripción </th>
      <td mat-cell *matCellDef="let element"> {{element.opcion.descripcion}} </td>
    </ng-container> -->

    <ng-container matColumnDef="respuesta">
      <th mat-header-cell *matHeaderCellDef> Respuesta </th>
      <td mat-cell *matCellDef="let element">
        <div *ngIf="element.opcion.esCumpleNoCumple">
          <mat-checkbox  class="example-margin" [(ngModel)]="element.cumpleNoCumple" 
          [disabled]="(!isResponsable || (isResponsable && analisisDeBrechasEstado!='PRE_INICIADO'))"
          (change)="saveValue(sentencia,element)">Cumple</mat-checkbox>
        </div>
        <div fxFlex="100" *ngIf=" (element.sentencias==null || element.sentencias.length==0)">
          <mat-form-field *ngIf="!element.opcion.esCumpleNoCumple" >
            <input matInput 
                [(ngModel)]="element.valor"
                onkeypress="return event.charCode >= 48"
                type="number"  [min]="element.opcion.valorMinimo" [max]="element.opcion.valorMaximo"  
                pattern="[0-9]+" 
                step="any" 
                (change)="saveValue(sentencia,element)"
                [disabled]="(!isResponsable || (isResponsable && analisisDeBrechasEstado!='PRE_INICIADO'))">
          </mat-form-field>
        </div>
        <!-- <div *ngIf=" (!isResponsable || (isResponsable && analisisDeBrechasEstado!='PRE_INICIADO'))">
          {{element?.valor | number}}
        </div> -->
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <div *ngIf="!esMultiple">
    
    <mat-form-field fxFlex="100" >
      <mat-select
      [compareWith]="compareObjects"
      [disabled]="(!isResponsable || (isResponsable && analisisDeBrechasEstado!='PRE_INICIADO'))"
      [(ngModel)]="sentencia.opcion" 
      class="roleSelect" 
      (selectionChange)="selectRespuesta(sentencia,$event)">
          <mat-option *ngFor="let opcion of tablaDeAnalisisDeBrechas?.opciones" [value]="opcion">
               {{opcion.valor | number}} ({{opcion.nombre}})
          </mat-option>
      </mat-select>
    </mat-form-field>
    <!-- <div *ngIf="(!isResponsable || (isResponsable && analisisDeBrechasEstado!='PRE_INICIADO'))">
      {{sentencia.opcion?.valor | number}} ({{sentencia.opcion?.nombre}})
    </div> -->
  </div>

</div>